var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#148740"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9993,
    cy: 12.0003,
    r: 7.33333,
    fill: "#148740"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7723 8.83195C16.0494 9.0744 16.0775 9.49558 15.8351 9.77267L11.1684 15.106C11.0418 15.2507 10.8589 15.3337 10.6667 15.3337C10.4744 15.3337 10.2916 15.2507 10.165 15.106L8.16496 12.8203C7.9225 12.5432 7.95058 12.122 8.22767 11.8796C8.50476 11.6371 8.92594 11.6652 9.16839 11.9423L10.6667 13.6546L14.8316 8.89466C15.0741 8.61757 15.4953 8.5895 15.7723 8.83195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.9e0350b5bd9cd029ccf482debc0b10a2.svg";
export { ForwardRef as ReactComponent };